import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Shearchbar from "./Shearchbar";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Security from "./Security";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import { ToastContainer, toast } from "react-toastify";
import { BsFillSuitHeartFill } from "react-icons/bs";
import { useCart } from "./CartContext";

const SearchProducts = () => {
  const navigate = useNavigate();
  const { triggerCartRefresh } = useCart();
  const searchnamelist = localStorage.getItem("searchname");
  const _id = secureLocalStorage.getItem("n_id");
  const token = secureLocalStorage.getItem("n_token");
  const [product_details, setproduct_details] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const formatPrice = (price) => {
    if (!price) return 0;
    return Number(price.toString().replace(/,/g, ""));
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const data = {
        user_id: _id,
        product_name: searchnamelist,
      };
      const res = await axios.post(
        `${process.env.REACT_APP_API}website/search_product_name`,
        data
      );
      
      if (res?.data?.result) {
        setproduct_details(res.data.data || []);
      }
    } catch (error) {
      console.log("Search error:", error);
    } finally {
      setLoading(false);
    }
  };

  const Single_products = (productId) => {
    if (token) {
      navigate(`/single_products/${productId}`);
    } else {
      navigate(`/login`);
    }
  };

  const add_to_cart = async (cart) => {
    try {
      const price = formatPrice(cart.sale_price);

      const data = {
        user_id: _id,
        product_id: cart.product_id,
        quantity: "1",
        no_of_product: 1,
        mrp: price,
        price: price,
        total_mrp_ammount: price,
        total_price_ammount: price,
        product_name: cart.product_title,
        product_image: cart.product_image,
      };

      const res = await axios.post(
        `${process.env.REACT_APP_API}website/add_to_cart`,
        data,
        { headers: { token } }
      );

      if (res.data?.result) {
        toast.success("Product added to cart ✅");
        triggerCartRefresh();
        fetchData();
      } else {
        toast.error(res.data?.msg || "Failed to add item");
      }
    } catch (error) {
      console.log("Cart error:", error);
      toast.error("Something went wrong");
    }
  };

  const addfevrate = async (productId) => {
    try {
      const items = {
        user_id: _id,
        product_id: productId,
      };

      const res = await axios.post(
        `${process.env.REACT_APP_API}website/add_favourite_product`,
        items,
        { headers: { token } }
      );

      if (res.data.result) {
        toast.success(res.data.msg);
        fetchData();
      } else {
        toast.error(res.data.msg);
      }
    } catch (error) {
      toast.error("Favourite update failed");
    }
  };

  return (
    <div>
      <ToastContainer position="top-center" />

      <header>
        <Shearchbar />
        <Navbar />
      </header>

      <div className="col-lg-12">
        <div className="row justify-content-center">

          {loading ? (
            <div className="row justify-content-center pb-5">
              <div className="loader"></div>
            </div>
          ) : product_details.length > 0 ? (
            product_details.map((items) => (
              <div
                key={items.product_id}
                className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12"
              >
                <div className="product-card">

                  <div className="product-thumb-nail">
                    <img
                      className="product-image p-2"
                      src={`${process.env.REACT_APP_API}uploads/${items.product_image}`}
                      alt={items.product_title}
                      onClick={() => Single_products(items.product_id)}
                    />

                    <ul className="actions">
                      {token ? (
                        items.favourite_status === "1" ? (
                          <li className="action whish-list">
                            <BsFillSuitHeartFill
                              style={{ color: "red" }}
                              onClick={() => addfevrate(items.product_id)}
                            />
                          </li>
                        ) : (
                          <li
                            className="action whish-list"
                            onClick={() => addfevrate(items.product_id)}
                          >
                            <i className="lar la-heart" />
                          </li>
                        )
                      ) : (
                        <li className="action whish-list">
                          <Link to="/login">
                            <i className="lar la-heart" />
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>

                  <div className="product-content">
                    <h4>{items.category_name}</h4>

                    <h3 onClick={() => Single_products(items.product_id)}>
                      {items.product_title}
                    </h3>

                    <div className="product-price-wrapp">
                      <span className="product-price-on-sale">
                        ₹{formatPrice(items.sale_price)}
                      </span>
                    </div>

                    <div className="product-cart-btn-wrap">
                      {token ? (
                        <button
                          className="btn btn-dark"
                          onClick={() => add_to_cart(items)}
                        >
                          Add to cart
                        </button>
                      ) : (
                        <Link to="/login">
                          <button className="btn btn-dark">
                            Add to cart
                          </button>
                        </Link>
                      )}
                    </div>
                  </div>

                </div>
              </div>
            ))
          ) : (
            <h3>No products found 😕</h3>
          )}
        </div>
      </div>

      <Security />
      <Footer />
    </div>
  );
};

export default SearchProducts;
